import { AnimatePresence, motion } from 'motion/react'
import { useContext, useEffect, useId } from 'react'
import {
  bottomWrapper,
  sideWrapper
} from '~/components/Layout/AsideActionWrapper/AsideActionWrapper.css'
import type { AsideActionPosition } from '~/types/global'
import { AsideActionContext } from '~/utils/contextes'

const OPEN_SIDEBAR_CLASS = 'has-aside-action'
const openSidebars = new Set<string>()

/** Legacy pages read `body.has-aside-action` to make room for the sidebar next to their modal boxes. */
const syncOpenSidebarClass = (id: string, isOpen: boolean) => {
  if (isOpen) {
    openSidebars.add(id)
  } else {
    openSidebars.delete(id)
  }
  document.body.classList.toggle(OPEN_SIDEBAR_CLASS, openSidebars.size > 0)
}

export const AsideActionWrapper = ({
  position = 'sidebar'
}: {
  position?: AsideActionPosition
}) => {
  const {
    asideAction,
    isWide,
    position: contextPosition
  } = useContext(AsideActionContext)
  const id = useId()
  const isOpenSidebar =
    asideAction !== null &&
    position === 'sidebar' &&
    contextPosition === position

  useEffect(() => {
    syncOpenSidebarClass(id, isOpenSidebar)
    return () => syncOpenSidebarClass(id, false)
  }, [id, isOpenSidebar])

  return (
    <AnimatePresence>
      {asideAction && contextPosition === position && (
        <motion.div
          className={position === 'bottom' ? bottomWrapper : sideWrapper}
          key="aside-action"
          initial={
            position === 'bottom'
              ? { opacity: 0, y: -10 }
              : { opacity: 0, flexBasis: '0', minWidth: 0 }
          }
          animate={
            position === 'bottom'
              ? { opacity: 1, y: 0 }
              : {
                  opacity: 1,
                  minWidth: isWide && position === 'sidebar' ? '700px' : 0,
                  flexBasis: isWide && position !== 'modal' ? '700px' : '500px'
                }
          }
          exit={
            position === 'bottom'
              ? { opacity: 0, y: -10 }
              : { opacity: 0, flexBasis: '0', minWidth: 0 }
          }
        >
          {asideAction}
        </motion.div>
      )}
    </AnimatePresence>
  )
}
